module.exports = __webpack_public_path__ + "img/successPurchase.db9282a2.svg";